<template>
  <div class="content">
        <div class="shell">
            <div class="articles-excerpt">
                <article-excerpt
                    v-for="article in articles"
                    :key="article.id"
                    :title="article.title"
                    :author="article.author"
                    :readingsCount="article.readings"
                    :rating="article.rating"
                    :coverSrc="article.image"
                    :url="article.url"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import ArticleExcerpt from '@/components/article-excerpt/article-excerpt'

export default {
    name: 'CategoryClassic',

    components: {
        ArticleExcerpt
    },

    setup() {
        const articles = ref([
            {
                id: '1',
                title: 'In your feelings',
                author: 'Sarah Perez',
                readings: 25,
                rating: '4.5',
                url: '/book/1',
                image: require('@/assets/images/temp/article-8.png')
            },
            {
                id: '2',
                title: 'Do you have the experience',
                author: 'Frank Lee',
                readings: 41,
                rating: '5.0',
                url: '/book/1',
                image: require('@/assets/images/temp/article-6.png')
            },
            {
                id: '3',
                title: 'Has anyone been living in',
                author: 'Simon',
                readings: 3,
                rating: '3.0',
                url: '/book/1',
                image: require('@/assets/images/temp/article-7.png')
            },
            {
                id: '4',
                title: 'The Killer Collective',
                author: 'Sarah Perez',
                readings: 7,
                rating: '5.0',
                url: '/book/1',
                image: require('@/assets/images/temp/article-4.png')
            },
            {
                id: '5',
                title: 'The Vocabulary of Style',
                author: 'John Woo',
                readings: 10,
                rating: '4.5',
                url: '/book/1',
                image: require('@/assets/images/temp/article-5.png')
            },
            {
                id: '6',
                title: 'Anne Brigman',
                author: 'James Franco',
                readings: 3,
                rating: '2.5',
                url: '/book/1',
                image: require('@/assets/images/temp/article-6.png')
            }
        ]);

        return {
            articles
        }
    }
}
</script>
